import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import FloatingOrbs from "@/components/effects/FloatingOrbs";

const NotFound = () => {
    return (
        <main className="relative flex min-h-screen items-center justify-center overflow-hidden bg-brand-bg px-6">
            <FloatingOrbs />
            <div aria-hidden className="pointer-events-none absolute inset-0 grid-bg" />

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                className="relative z-10 max-w-xl text-center"
            >
                <p className="overline">404</p>
                <h1
                    className="mt-4 text-6xl font-semibold tracking-tighter text-white sm:text-7xl md:text-8xl gradient-accent"
                    style={{ fontFamily: "'General Sans', sans-serif" }}
                >
                    Not found.
                </h1>
                <p className="mx-auto mt-6 max-w-md text-base text-brand-muted md:text-lg">
                    The page you&apos;re looking for doesn&apos;t exist — or it hasn&apos;t been built yet.
                </p>
                <Link to="/" className="btn-primary mt-8 inline-flex">
                    Back to home
                </Link>
            </motion.div>
        </main>
    );
};

export default NotFound;
